// ** Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";

// #####################################################

const DataEducation = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const partnersEducation = useSelector(
		(state) => state.userProfileMain.partners.education
	);

	// #####################################################

	return (
		partnersEducation.filter((item) => item === 0 || item).length !== 0 && (
			<Block>
				<Text>{t("filtersAndSelectors:educationLabel")}:</Text>{" "}
				<Text bold>
					{partnersEducation
						.filter((item) => item !== null)
						.map((item) =>
							t(`filtersAndSelectors:education.${item}`)
						)
						.join(` ${t("common:and")} `)}
				</Text>
			</Block>
		)
	);
};

// #####################################################

export default DataEducation;

// #####################################################
